(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .service('DownloadUtil', DownloadUtil);

    DownloadUtil.$inject = [];

    function DownloadUtil() {
        this.getFilenameFromContentDisposition = function(cd) {
            if (!cd || typeof cd !== 'string') return 'download';
            try {
                // Prefer RFC 5987 filename*
                var starMatch = cd.match(/filename\*=([^;]+)/i);
                if (starMatch && starMatch[1]) {
                    var v = starMatch[1].trim();
                    var parts = v.split("''"); // UTF-8''<percent-encoded>
                    if (parts.length === 2) {
                        try { return decodeURIComponent(parts[1]); } catch (e) { return parts[1]; }
                    }
                    v = v.replace(/^UTF-8''/i, '');
                    try { return decodeURIComponent(v.replace(/^\"|\"$/g, '')); } catch (e) { return v.replace(/^\"|\"$/g, ''); }
                }

                // Fallback: filename=
                var simple = cd.match(/filename=([^;]+)/i);
                if (simple && simple[1]) {
                    var name = simple[1].trim();
                    if ((name.charAt(0) === '"' && name.charAt(name.length - 1) === '"') ||
                        (name.charAt(0) === "'" && name.charAt(name.length - 1) === "'")) {
                        name = name.substring(1, name.length - 1);
                    }
                    return name;
                }
            } catch (e) {}
            return 'download';
        };
    }
})();

